module.exports = __webpack_public_path__ + "static/img/login_bg1.8059e8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/loginLuobei/img/login_bg1.jpg
// module id = lk3f
// module chunks = 202